const config = {
  gmaps_api_key: "AIzaSyAYlJIHAjK8lNKuJFSyaV6dH1gUyJZdGQM",
};

export default config;
